import React from "react";

const useFocus = <T extends HTMLElement>() => {
    const htmlElRef = React.useRef(null as unknown as T);
    const setFocus = () => {
        if (htmlElRef.current) {
            htmlElRef.current.focus();
        }
    };

    return { htmlElRef, setFocus };
};

export default useFocus;


// WEBPACK FOOTER //
// ./src/CustomHooks/useFocus.ts